export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxNl4c5yjTjQJElti5.f74c2016.woff2";